// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uuno","right":"styles_right__29tin"};